import { hexToRGBa } from './colorCodeConverter';
import { getOpacity } from './animations';

export interface DrawBackdropProps {
  position: number;
  context: CanvasRenderingContext2D;
  width: number;
  height: number;
  color: string; // Hex Code only
  speed?: number;
}

export const drawBackdrop = ({
  position,
  context,
  width,
  height,
  color,
  speed,
}: DrawBackdropProps) => {
  const opacity = getOpacity(position, speed);
  if (!opacity) {
    return;
  }
  context.beginPath();
  context.rect(0, 0, width, height);
  context.fillStyle = hexToRGBa(color, opacity);
  context.fill();
};
